import CityPageTemplate from "../city-template/CityPageTemplate";
import { plymouthConfig } from "./data";

export default function PlymouthPage() {
  return <CityPageTemplate config={plymouthConfig} />;
}